const baseStyle = {
  color: `heading`,
  fontWeight: `medium`,
};

const variants = {
  inactive: {
    opacity: 0.5,
  },
  active: {
    opacity: 1,
  },
  red: {
    color: `primary.base`,
  },
};

const defaultProps = {
  variant: `active`,
};

export const Anchor = {
  baseStyle,
  variants,
  defaultProps,
};
